export class NICECampaign {
    campaignId: number;
    campaignName: string;
    description: string;
    notes: string;
    isActive: boolean;

    constructor(niceCampaign?) {
        if (niceCampaign) {
            this.campaignId = +niceCampaign.campaignId || 0;
            this.campaignName = niceCampaign.campaignName || '';
            this.description = niceCampaign.description || '';
            this.notes = niceCampaign.notes || '';
            this.isActive = niceCampaign.isActive === 'True';
        }else{
            this.campaignName = '';
            this.description = '';
            this.notes = '';
            this.isActive = true;
        }
    }
}
